import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AccountDetailRequestBody, AccountDetailResponse } from "./types";

export class AccountDetailAPI extends BaseAPI<
  AccountDetailRequestBody,
  AccountDetailResponse
> {
  protected route = ApiRoutes.account.detail;
  protected method = RequestMethod.GET;
  protected params = ["accountId"];
}
